var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{style:('min-height:' + _vm.height + ' !important'),attrs:{"src":_vm.docURL,"width":"100%","height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }